var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('button',{ref:"focusMe",staticClass:"btn btn-link btn-back",attrs:{"title":"Zurück"},on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":"/assets/icons/left-arrow.png","alt":"Zurück"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }